import { Typography, Paper, Box } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import type { HolidayBlock as HolidayBlockType } from './entity';

type HolidayBlockProps = {
  holiday: HolidayBlockType;
};

const HolidayBlock = ({ holiday }: HolidayBlockProps) => {
  return (
    <Paper
      elevation={0}
      sx={{
        position: 'absolute',
        top: holiday.top,
        left: 0,
        right: 0,
        height: holiday.height,
        backgroundColor: 'rgba(211, 47, 47, 0.15)',
        color: 'error.dark',
        padding: 1,
        cursor: 'not-allowed',
        border: '2px solid',
        borderColor: 'error.main',
        opacity: 0.9,
        overflow: 'hidden',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        background:
          'repeating-linear-gradient(45deg, rgba(211, 47, 47, 0.05), rgba(211, 47, 47, 0.05) 10px, rgba(211, 47, 47, 0.15) 10px, rgba(211, 47, 47, 0.15) 20px)',
      }}
    >
      <BlockIcon fontSize="small" />
      <Box>
        <Typography variant="caption" fontWeight="bold" display="block">
          {holiday.startTime} - {holiday.endTime}
        </Typography>
        <Typography variant="caption" sx={{ fontStyle: 'italic' }}>
          {holiday.name || 'Blocked'}
        </Typography>
      </Box>
    </Paper>
  );
};

export default HolidayBlock;
